module.exports = __webpack_public_path__ + "img/default-browse-vehicles-red.6c703df0.png";